// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__2GZOc","title":"Error_title__ESbTN","back":"Error_back__2OLVG"};